<script setup>
// @ts-check

import { onClickOutside } from '@vueuse/core'
import { ref } from 'vue'

defineProps({
  id: {
    type: String,
    required: true
  },
  label: {
    type: String,
    default: null
  },
  /**
   * To force full width menu
   */
  fullWidth: {
    type: Boolean
  }
})

const wrapper = ref(null)

const isOpen = ref(false)

const close = () => {
  isOpen.value = false
}

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

onClickOutside(wrapper, close)
</script>

<template>
  <div ref="wrapper" class="relative">
    <slot name="button" :toggle="toggleDropdown" :open="isOpen">
      <button
        :id
        type="button"
        class="flex w-full items-center justify-between truncate rounded-xs border border-secondary-200 bg-white px-4 py-3 whitespace-nowrap text-secondary-600"
        :aria-label="label"
        aria-haspopup="true"
        :aria-expanded="`${isOpen}`"
        @click="toggleDropdown"
      >
        {{ label }}

        <VIcon
          :icon="isOpen ? '$chevron-down' : '$chevron-up'"
          class="fill-current text-secondary-600"
        />
      </button>
    </slot>

    <Transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-show="isOpen && $slots.default"
        class="absolute z-10 rounded-md border border-secondary-100 bg-white shadow-lg"
        :class="[
          fullWidth ? 'w-full' : 'right-0 mt-2 min-w-48 origin-top-right'
        ]"
        role="menu"
        aria-orientation="vertical"
        :aria-labelledby="id"
        @click.capture="close"
      >
        <slot />
      </div>
    </Transition>
  </div>
</template>
